module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/feature03-94077afc2fda090f30348cd68f64657b.svg";